"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Save = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
function initUser(channel, activeUser) {
    return {
        id: null,
        name: '',
        email: '',
        channels: activeUser.is_admin ? [] : [channel.id],
        channel_id: channel.id,
        role_id: 0,
        verify: true
    };
}
var Save = function (_a) {
    var id = _a.id, activeUser = _a.activeUser, _b = _a.channel, channel = _b === void 0 ? {} : _b;
    var _c = storybook_1.Hooks.useModal(), Modal = _c[0], setModal = _c[1];
    var _d = storybook_1.Helpers.useSave('auth', 'users', initUser(channel, activeUser), { id: id, channel_id: channel.id }), user = _d[0], setUser = _d[1], submitUser = _d[2];
    function onSubmit() {
        submitUser().then(function (response) {
            if (!response.errors.length) {
                var modalMessage_1 = id ? 'De gebruiker is succesvol aangepast' : 'De gebruiker is succesvol aangemaakt';
                setModal({
                    content: function () { return react_1.default.createElement(storybook_1.Forms.Success, { title: modalMessage_1, returnUrl: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/users" }); }
                });
            }
        });
    }
    if (user.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    if (id && !user.data.id) {
        return react_1.default.createElement(storybook_1.Pages.Dashboard.NotFound, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Modal, null),
        react_1.default.createElement(storybook_1.Forms.Form, null,
            react_1.default.createElement(storybook_1.Layouts.Container, { type: 'sm', className: 'storybook-layouts-space' },
                react_1.default.createElement(storybook_1.Users.Form, { setUser: setUser, activeUser: activeUser, user: user, submit: onSubmit, channel: channel }),
                react_1.default.createElement(storybook_1.Forms.Buttons, { loading: user.submitting, submit: onSubmit, errors: user.errors })))));
};
exports.Save = Save;
exports.Save.propTypes = {
    /**
     * User ID for editing.
     */
    id: prop_types_1.default.number,
};
exports.Save.defaultProps = {
    id: null,
};
